module.exports = __webpack_public_path__ + "img/shop-photo8.7a05bfce.jpg";